export default "/images/PhysiciansWeekly.jpg?2ef9951826e9eac725ffcf7cc4a5ca87";